import { TokenManager } from "utils/tokenManager";

const ImpersonationBanner = () => {
  const isImpersonating = TokenManager.isImpersonating();

  if (!isImpersonating) return null;

  const impersonatingAs = localStorage.getItem("impersonatingAs") || "Unknown";
  const impersonatingName = localStorage.getItem("impersonatingName") || "";

  const handleExit = () => {
    const returnPath = localStorage.getItem("impersonatingReturnPath");
    TokenManager.restoreOriginalState();
    window.location.href = returnPath || "/superadmin/dashboard";
  };

  return (
    <div className="flex items-center justify-between gap-3 rounded-lg bg-amber-50 border border-amber-200 px-4 py-2.5 mb-4">
      <div className="flex items-center gap-2">
        <span className="inline-flex items-center rounded-md bg-amber-100 px-2 py-1 text-xs font-medium text-amber-800">
          View Only
        </span>
        <span className="text-sm text-amber-800">
          Viewing as <strong>{impersonatingAs}</strong>
          {localStorage.getItem("subaccountId")
            ? `: ${localStorage.getItem("subaccountName") || ""}`
            : localStorage.getItem("merchantId")
            ? `: ${localStorage.getItem("merchantName") || ""}`
            : ""}
        </span>
      </div>
      <button
        onClick={handleExit}
        className="rounded-md bg-amber-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-amber-700 transition-colors"
      >
        Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
